<template>
  <div class="sidebar">
    <ul class="nav-tabs">
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{ active: activeTab === tab.id }"
        @click="$emit('update:activeTab', tab.id)"
      >
        <img class="tab-icon" :src="tab.icon" alt="" />
        <p class="tab-name">{{ tab.name }}</p>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  }
};
</script>

<style scoped>
.sidebar {
  width: 22.55vw;
  min-width: 22.55vw; /* ← ДОБАВЬ */
  flex-shrink: 0;
  background-color: #8c66ad;
  padding-top: 9.9vw;
  height: 100vh;
  border-right: 1px solid #333;
}

.nav-tabs {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-tabs li {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: wheat;
  padding: 0 0 0 3.33vw;
  position: relative;
  transition: color 0.3s ease;
}

.nav-tabs li:hover,
.nav-tabs li.active {
  color: white;
}

/* Подчёркивание при наведении и активности */
.nav-tabs li::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 3.13vw;
  right: 3.13vw;
  height: 1px;
  background-color: white;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-tabs li:hover::after,
.nav-tabs li.active::after {
  transform: scaleX(1);
}

.tab-icon {
  width: 2.08vw;
  margin-right: 0.52vw;
  flex-shrink: 0;
}
.close-btn {
  display: none;
}
.tab-name {
  font-weight: 400;
}

/* === Мобильная версия === */
@media (max-width: 768px) {
  .close-btn {
    border: none;
    background: transparent;
    font-size: 1.3rem;
    color: #fff;
    cursor: pointer;
    display: block;
  }
  .sidebar {
    width: 100%;
    height: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    border-right: none;
    background-color: #262626f3;
    border-radius: 0 0 15px 15px;
    z-index: 4;
    padding: 0;
  }

  .nav-tabs {
    display: flex;
    justify-content: space-evenly; /* или space-between */
    align-items: top;
    height: 100%; /* растягиваем по высоте всего сайдбара */
    margin: 0;
    padding: 0; /* минимальные боковые отступы */
    gap: 0; /* ← главное изменение — убираем промежутки */
  }

  .nav-tabs li {
    flex: 0 0 15%; /* или 20% если 5 вкладок */ /* равномерно распределяют пространство */
    display: flex;
    flex-direction: column;
    align-items: top;
    justify-content: top;
    padding-left: 4px;
    padding-top: 4px; /* очень маленькие внутренние отступы */
    min-width: 0; /* позволяет сжиматься при необходимости */
    gap: 5px;
  }

  .nav-tabs li::after {
    left: 2.302vw;
    right: 0.902vw;
    bottom: 0.521vw;
  }

  .tab-icon {
    width: 6.125vw;
    height: auto;
    margin-right: 0;
    margin-bottom: 0;
  }
  .tab-name {
    font-size: 2.8vw;
    text-align: center;
    white-space: normal;

    margin-top: 1px;
    padding: 0 2px;
  }
}
</style>